import { useRouter } from "next/router";

export const useCurrentArticleLevelId = (): string | undefined => {
  const router = useRouter();
  const {
    query: { levelId },
  } = router || {};

  if (!levelId) {
    return undefined;
  }

  return levelId as string;
};

export default useCurrentArticleLevelId;
